import { createPortal } from 'react-dom';
import { useEffect } from 'react';

type Props = {
  open: boolean;
  onClose: () => void;
  src: string;
};

/**
 * Video modal overlay – render to body
 * Modal video phủ toàn màn hình, chặn toàn bộ nền phía dưới
 */
export function VideoModal({ open, onClose, src }: Props) {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden'; // disable scroll
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  if (!open) return null;

  return createPortal(
    <div className='fixed inset-0 z-[9999] bg-black/90 flex items-center justify-center' onClick={onClose}>
      <div className='flex items-center justify-center w-full h-full' onClick={(e) => e.stopPropagation()}>
        {/* Wrapper neo theo video */}
        <div className='relative'>
          <button
            onClick={onClose}
            className='absolute
              -top-5
              -right-5
              z-10
              flex
              h-10
              w-10
              items-center
              justify-center
              rounded-full
              bg-black/70
              text-white
              text-2xl
              hover:bg-black/90'
          >
            ×
          </button>
          <video autoPlay controls className='h-[95vh] w-auto max-w-[95vw] rounded-lg'>
            <source src={src} type='video/mp4' />
          </video>
        </div>
      </div>
    </div>,
    document.body,
  );
}
